<template>
	<svg
		width="233"
		height="67"
		viewBox="0 0 233 67"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M224.37 67H8.62963C3.88549 67 0 63.2292 0 58.625V8.37501C0 3.77086 3.88549 1.53513e-05 8.62963 1.53513e-05H224.37C229.115 1.53513e-05 233 3.77086 233 8.37501V58.625C233 63.2292 229.115 67 224.37 67Z"
			fill="black"
		/>
		<path
			d="M224.37 1.3421C228.366 1.3421 231.617 4.49739 231.617 8.37501V58.625C231.617 62.5026 228.366 65.6579 224.37 65.6579H8.62963C4.63411 65.6579 1.3829 62.5026 1.3829 58.625V8.37501C1.3829 4.49739 4.63411 1.3421 8.62963 1.3421H224.37ZM224.37 1.53513e-05H8.62963C3.88549 1.53513e-05 0 3.77086 0 8.37501V58.625C0 63.2292 3.88549 67 8.62963 67H224.37C229.115 67 233 63.2292 233 58.625V8.37501C233 3.77086 229.115 1.53513e-05 224.37 1.53513e-05Z"
			fill="#A6A6A6"
		/>
		<path
			d="M81.8396 17.1584C81.8396 18.5571 81.4081 19.6772 80.5581 20.5126C79.5807 21.503 78.3078 22.0013 76.7479 22.0013C75.257 22.0013 73.9841 21.4946 72.9399 20.4959C71.8935 19.4825 71.3713 18.2388 71.3713 16.7501C71.3713 15.2615 71.8935 14.0178 72.9399 13.0128C73.9841 12.0057 75.257 11.499 76.7479 11.499C77.4901 11.499 78.1977 11.6477 78.873 11.9241C79.5462 12.2025 80.0942 12.5794 80.4912 13.0442L79.5893 13.9278C78.8968 13.1342 77.9539 12.7427 76.7479 12.7427C75.6605 12.7427 74.7177 13.1112 73.9172 13.8545C73.1254 14.5999 72.7284 15.5651 72.7284 16.7501C72.7284 17.9352 73.1254 18.9088 73.9172 19.6542C74.7177 20.3891 75.6605 20.766 76.7479 20.766C77.9022 20.766 78.8731 20.3891 79.639 19.6458C80.1438 19.1538 80.4308 18.4754 80.5063 17.6086H76.7479V16.3984H81.762C81.8224 16.6601 81.8396 16.9135 81.8396 17.1584Z"
			fill="white"
			stroke="white"
			stroke-width="0.207407"
			stroke-miterlimit="10"
		/>
		<path
			d="M89.7937 12.9625H85.0838V16.145H89.3298V17.3552H85.0838V20.5377H89.7937V21.7709H83.7505V11.7292H89.7937V12.9625Z"
			fill="white"
			stroke="white"
			stroke-width="0.207407"
			stroke-miterlimit="10"
		/>
		<path
			d="M95.4071 21.7709H94.0737V12.9625H91.1848V11.7292H98.2982V12.9625H95.4071V21.7709Z"
			fill="white"
			stroke="white"
			stroke-width="0.207407"
			stroke-miterlimit="10"
		/>
		<path
			d="M103.446 21.7709V11.7292H104.777V21.7709H103.446Z"
			fill="white"
			stroke="white"
			stroke-width="0.207407"
			stroke-miterlimit="10"
		/>
		<path
			d="M110.677 21.7709H109.355V12.9625H106.455V11.7292H113.577V12.9625H110.677V21.7709Z"
			fill="white"
			stroke="white"
			stroke-width="0.207407"
			stroke-miterlimit="10"
		/>
		<path
			d="M127.044 20.4791C126.023 21.4946 124.759 22.0013 123.251 22.0013C121.734 22.0013 120.47 21.4946 119.449 20.4791C118.431 19.4657 117.924 18.2221 117.924 16.7501C117.924 15.2782 118.431 14.0346 119.449 13.0212C120.47 12.0057 121.734 11.499 123.251 11.499C124.75 11.499 126.015 12.0057 127.035 13.0296C128.062 14.0513 128.569 15.2866 128.569 16.7501C128.569 18.2221 128.062 19.4657 127.044 20.4791ZM120.435 19.6374C121.203 20.3891 122.137 20.766 123.251 20.766C124.355 20.766 125.298 20.3891 126.058 19.6374C126.824 18.8858 127.212 17.9206 127.212 16.7501C127.212 15.5797 126.824 14.6145 126.058 13.8629C125.298 13.1112 124.355 12.7343 123.251 12.7343C122.137 12.7343 121.203 13.1112 120.435 13.8629C119.669 14.6145 119.281 15.5797 119.281 16.7501C119.281 17.9206 119.669 18.8858 120.435 19.6374Z"
			fill="white"
			stroke="white"
			stroke-width="0.207407"
			stroke-miterlimit="10"
		/>
		<path
			d="M130.439 21.7709V11.7292H132.057L137.089 19.5389H137.147L137.089 17.6085V11.7292H138.42V21.7709H137.03L131.762 13.5759H131.704L131.762 15.5147V21.7709H130.439Z"
			fill="white"
			stroke="white"
			stroke-width="0.207407"
			stroke-miterlimit="10"
		/>
		<path
			d="M117.596 36.4355C113.542 36.4355 110.23 39.4295 110.23 43.5605C110.23 47.658 113.542 50.6834 117.596 50.6834C121.658 50.6834 124.97 47.658 124.97 43.5605C124.97 39.4295 121.658 36.4355 117.596 36.4355ZM117.596 47.8778C115.371 47.8778 113.458 46.096 113.458 43.5605C113.458 40.9915 115.371 39.2411 117.596 39.2411C119.82 39.2411 121.742 40.9915 121.742 43.5605C121.742 46.096 119.82 47.8778 117.596 47.8778ZM101.525 36.4355C97.4628 36.4355 94.1598 39.4295 94.1598 43.5605C94.1598 47.658 97.4628 50.6834 101.525 50.6834C105.585 50.6834 108.891 47.658 108.891 43.5605C108.891 39.4295 105.585 36.4355 101.525 36.4355ZM101.525 47.8778C99.2988 47.8778 97.3787 46.096 97.3787 43.5605C97.3787 40.9915 99.2988 39.2411 101.525 39.2411C103.749 39.2411 105.663 40.9915 105.663 43.5605C105.663 46.096 103.749 47.8778 101.525 47.8778ZM82.402 38.6192V41.6468H89.8515C89.6336 43.3386 89.0511 44.5822 88.1579 45.4491C87.0706 46.4959 85.377 47.658 82.402 47.658C77.8175 47.658 74.2275 44.0672 74.2275 39.618C74.2275 35.1688 77.8175 31.578 82.402 31.578C84.8808 31.578 86.6844 32.5181 88.0155 33.7366L90.2139 31.6031C88.3521 29.8778 85.8754 28.5525 82.402 28.5525C76.1153 28.5525 70.8318 33.5168 70.8318 39.618C70.8318 45.7192 76.1153 50.6834 82.402 50.6834C85.7999 50.6834 88.3521 49.6031 90.3585 47.5763C92.4145 45.581 93.0552 42.7753 93.0552 40.5099C93.0552 39.8064 92.9948 39.1594 92.887 38.6192H82.402ZM160.599 40.9663C159.993 39.373 158.123 36.4355 154.313 36.4355C150.537 36.4355 147.394 39.3227 147.394 43.5605C147.394 47.5512 150.505 50.6834 154.675 50.6834C158.047 50.6834 159.993 48.6881 160.793 47.5261L158.291 45.9076C157.456 47.0927 156.319 47.8778 154.675 47.8778C153.042 47.8778 151.87 47.1513 151.12 45.7192L160.938 41.7766L160.599 40.9663ZM150.589 43.3386C150.505 40.5916 152.787 39.1846 154.423 39.1846C155.704 39.1846 156.792 39.8064 157.154 40.6962L150.589 43.3386ZM142.609 50.25H145.836V29.3125H142.609V50.25ZM137.323 38.0225H137.215C136.49 37.1892 135.107 36.4355 133.356 36.4355C129.679 36.4355 126.318 39.5677 126.318 43.5835C126.318 47.5763 129.679 50.6834 133.356 50.6834C135.107 50.6834 136.49 49.9234 137.215 49.065H137.323V50.0867C137.323 52.8107 135.824 54.2742 133.405 54.2742C131.433 54.2742 130.21 52.8923 129.705 51.7303L126.898 52.8672C127.707 54.7558 129.85 57.0798 133.405 57.0798C137.189 57.0798 140.382 54.9191 140.382 49.6617V36.8689H137.323V38.0225ZM133.632 47.8778C131.407 47.8778 129.546 46.0709 129.546 43.5835C129.546 41.0731 131.407 39.2411 133.632 39.2411C135.824 39.2411 137.552 41.0731 137.552 43.5835C137.552 46.0709 135.824 47.8778 133.632 47.8778ZM175.71 29.3125H167.991V50.25H171.209V42.3168H175.71C179.285 42.3168 182.79 39.8064 182.79 35.8136C182.79 31.8229 179.276 29.3125 175.71 29.3125ZM175.794 39.4044H171.209V32.2249H175.794C178.197 32.2249 179.569 34.1617 179.569 35.8136C179.569 37.4342 178.197 39.4044 175.794 39.4044ZM195.692 36.3957C193.366 36.3957 190.948 37.3923 189.953 39.6012L192.809 40.7632C193.424 39.6012 194.555 39.2243 195.75 39.2243C197.42 39.2243 199.113 40.1979 199.139 41.9169V42.1367C198.557 41.8101 197.31 41.3265 195.776 41.3265C192.699 41.3265 189.565 42.9701 189.565 46.0374C189.565 48.843 192.085 50.6499 194.917 50.6499C197.083 50.6499 198.278 49.7015 199.029 48.5981H199.139V50.2165H202.248V42.1849C202.248 38.4727 199.392 36.3957 195.692 36.3957ZM195.303 47.8694C194.251 47.8694 192.784 47.3627 192.784 46.096C192.784 44.4755 194.613 43.8536 196.197 43.8536C197.614 43.8536 198.278 44.1572 199.139 44.5571C198.887 46.4959 197.167 47.8694 195.303 47.8694ZM213.574 36.8542L209.874 45.9306H209.764L205.939 36.8542H202.468L208.215 49.5381L204.936 56.5962H208.3L217.156 36.8542H213.574ZM184.559 50.25H187.787V29.3125H184.559V50.25Z"
			fill="white"
		/>
		<path
			d="M18.0109 12.6273C17.5039 13.1423 17.2104 13.9442 17.2104 14.9827V52.0254C17.2104 53.0639 17.5039 53.8658 18.0109 54.3808L18.136 54.4939L39.5257 33.7448V33.2549L18.136 12.5058L18.0109 12.6273Z"
			fill="url(#paint0_linear_94:37167)"
		/>
		<path
			d="M46.6457 40.665L39.5237 33.7452V33.2553L46.6543 26.3354L46.814 26.4254L55.2585 31.0882C57.6685 32.4115 57.6685 34.589 55.2585 35.9206L46.814 40.575L46.6457 40.665Z"
			fill="url(#paint1_linear_94:37167)"
		/>
		<path
			d="M46.8145 40.5749L39.5247 33.5001L18.011 54.3811C18.8114 55.1976 20.1166 55.296 21.6009 54.4795L46.8145 40.5749Z"
			fill="url(#paint2_linear_94:37167)"
		/>
		<path
			d="M46.8145 26.425L21.6009 12.5204C20.1166 11.7122 18.8114 11.8106 18.011 12.6272L39.5247 33.4998L46.8145 26.425Z"
			fill="url(#paint3_linear_94:37167)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_94:37167"
				x1="37.6266"
				y1="52.4111"
				x2="9.5287"
				y2="23.4574"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#00A0FF" />
				<stop offset="0.0066" stop-color="#00A1FF" />
				<stop offset="0.2601" stop-color="#00BEFF" />
				<stop offset="0.5122" stop-color="#00D2FF" />
				<stop offset="0.7604" stop-color="#00DFFF" />
				<stop offset="1" stop-color="#00E3FF" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_94:37167"
				x1="58.3967"
				y1="33.4979"
				x2="16.6324"
				y2="33.4979"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#FFE000" />
				<stop offset="0.4087" stop-color="#FFBD00" />
				<stop offset="0.7754" stop-color="#FFA500" />
				<stop offset="1" stop-color="#FF9C00" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_94:37167"
				x1="42.8505"
				y1="29.6541"
				x2="4.74745"
				y2="-9.60738"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#FF3A44" />
				<stop offset="1" stop-color="#C31162" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_94:37167"
				x1="12.5955"
				y1="66.7046"
				x2="29.6103"
				y2="49.1728"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#32A071" />
				<stop offset="0.0685" stop-color="#2DA771" />
				<stop offset="0.4762" stop-color="#15CF74" />
				<stop offset="0.8009" stop-color="#06E775" />
				<stop offset="1" stop-color="#00F076" />
			</linearGradient>
		</defs>
	</svg>
</template>

<script>
export default {
	name: 'PlayStoreIcon',
}
</script>
